export default __webpack_public_path__ + "static/media/Lora-Italic-VariableFont_wght.7136aa6e.ttf";